import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesEnum } from '@app/core/utils';
import { map, take } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const fetchProfileGuard: CanActivateFn = () => {
    const authenticationService = inject(AuthenticationService);
    const router = inject(Router);

    return authenticationService.userHasNoPermissions$.pipe(
        take(1),
        map((error) => {
            if (error) {
                return router.createUrlTree([RoutesEnum.NO_PERMISSIONS]);
            }

            return true;
        }),
    );
};
